import React, { Component } from 'react'
import FixedView from '../components/FixedView'
import { checkTranslation, imageAddress, translate } from '../utils/useful'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import HttpServices from '../utils/Http.services'
import { widgetsList } from '../variables/widgetsList';
import ReactLoaderSpinner from 'react-loader-spinner';
import StagesManager from '../components/StagesManager';
import HelpButton from '../components/HelpButton';

class PageBuilderAddElements extends Component {

    state = {
        fixed: true,
        allApplets: [],
        frames: [],
        applets: [],
        currentApplet: {},
        fromApplet: true,
        selectedParent: {},
        isLoadingData: false,
        systemSections: [
            { type: 'general', mode: 'system', name: 'General widgets', icon: '/assets/icons/useful/dashboard (1).png' },
            { type: 'system', mode: 'system', name: 'System widgets', icon: '/assets/icons/useful/setting (1).png' },
            { type: 'template', mode: 'system', name: 'Template sections', icon: '/assets/icons/useful/subtitle.png' },

            // { type: 'controlUnits', mode: 'system', name: 'Control units', icon: '/assets/icons/useful/dashboard (1).png' },
            // { type: 'thirdParties', mode: 'system', name: 'Third Parties', icon: '/assets/icons/useful/api.png' },
        ],
    }

    componentDidMount() {
        // this.fetcAllApplets()
        this.getMyApplets()

    }

    openFirstView = () => {
        let view = this.state.fixed
        this.setState({ fixed: !view }, () => {
            if (this.state.fixed == true) {
                this.firstView.hideView()
            } else {
                this.firstView.showView()
                setTimeout(() => {
                    this.setState({ showFixed: true })
                    this.selectDefaultSection()
                }, 100);
            }
        })
    }

    selectDefaultSection = () => {
        let defaultSection = this.state.selectedParent?.type
        if (!this.state.defaultIsDone && !defaultSection) {

            defaultSection = "general"

            this.setState({ defaultIsDone: true })
        }

        this.state.systemSections.forEach(section => {
            if (section.type == defaultSection) {
                this.chooseParent(section)
            }
        });

    }


    getMyApplets = () => {
        let data = {}
        data.username = this.props.variables?.hub?.username
        this.setState({ isLoadingData: true })
        HttpServices.request('getHubByUsername', data, (fetchResult, fetchError) => {

            this.setState({ isLoadingData: false }, () => {
            })


            if (fetchError) {
                return
            }
            fetchResult.applets.forEach(element => {
                element.isParent = true
            });
            fetchResult.applets?.forEach(element => {
                if (element.applet?._id == this.props.variables?.appletId) {
                    this.selectApplet(element.applet)
                }
            });

            this.setState({ applets: fetchResult.applets }, () => {
                // this.setFrame(this.state.applets[0])
            })

        })
    }
    getFrames = (applet, cb) => {
        HttpServices.request('getFrames', { applet }, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.setState({ frames: (fetchResult.info ?? []) }, () => {
                if (cb) {
                    cb()
                }
            })
        })
    }
    setFrame = (item) => {
        this.chooseParent(item)
        // this.setState({ currentSelect: item.applet }, () => {
        // })
    }


    selectApplet = (item) => {
        this.getFrames(item, () => {


            this.setState({ currentApplet: item }, () => {
            })
            if (this.stageManager) {
                this.stageManager.changeStage('appletSelected')
            }
        })
    }



    chooseParent = (data) => {

        let item = data
        if (data.mode == 'system') {
            item = data
            if (this.stageManager) {
                if (data.type == 'thirdParties') {
                    this.stageManager.changeStage('thirdParties')
                } else if (data.type == 'applets') {
                    this.stageManager.changeStage('applets')
                } else {
                    this.stageManager.changeStage('units')
                }
            }

            this.setState({ selectedParent: data })


        } else {
            this.stageManager.changeStage('units')
            let myData = { ...data }
            // data.type = data?.features ? data.features[0] : ''
            this.setState({ selectedParent: myData.applet })

        }


    }



    onDragStart = (e, rowId, type) => {

        // console.log("onDragStart")
        // console.log(type)

        if (e.dataTransfer.setData) {
            e.dataTransfer.setData("type", type);
            e.dataTransfer.setData("dropType", "NEW");
            if (this.state.currentApplet) {
                e.dataTransfer.setData("currentApplet", this.state.currentApplet?._id);
            } else if (this.props.applet) {
                e.dataTransfer.setData("currentApplet", this.props.applet?._id);

            }
        } else {
            e.dataTransfer.rowId = rowId;
            e.dataTransfer.type = type;
            e.dataTransfer.dropType = "NEW";
        }
        this.props.onDragStartAction(e, type)
        setTimeout(() => {
            this.firstView.hideView()
        }, 100);
    };


    fetcAllApplets = () => {
        let username
        let allApplets = this.state.allApplets
        if (this.props?.user?.info?.username) {
            username = this.props.user?.info?.username
        }
        this.setState({ isLoadingData: true })
        HttpServices.request('getHubByUsername', { username: username }, (fetchResult, fetchError) => {
            this.setState({ isLoadingPost: false })
            if (fetchError) {
                // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                return
            }
            // { console.log('usernameeeeeeeeeeees', fetchResult) }
            fetchResult.applets.forEach(applet => {
                if (applet?.applet?.features && applet?.applet?.features[0]) {
                    allApplets.push(applet)
                }
            });
            // console.log('this.props.applet', this.props.applet)
            this.setState({ allApplets }, () => {
                if (this.props.applet) {
                    fetchResult.applets.forEach(applet => {
                        // console.log('appppppppppppplet issssss', applet)
                        // console.log('apppppppppppppppppppplet1', applet?.applet?._id)
                        // console.log('apppppppppppppppppppplet2', this.props.applet?._id)
                        if (applet?.applet?._id == this.props.applet?._id) {
                            // console.log('apppppppppppppppppppplet', applet)
                            let selectedParent = this.state.selectedParent
                            let slug = String(applet?.applet?.slug).charAt(0).toLocaleUpperCase() + String(applet?.applet?.slug).slice(1)
                            selectedParent.type = applet?.features[0] ?? slug
                            this.setState({ currentApplet: applet?.applet, fromApplet: true, selectedParent }, () => {
                                // console.log('xxxxxxxxxxxxxxxxxxxxxxxx', this.state.currentApplet, selectedParent)
                            })
                        }
                    });
                }
                else {
                    this.setApplet(allApplets[0].applet)
                }
                this.setState({ isLoadingData: false })
            })
            // this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}info.postSuccesfullyDesc' })
        })
    }

    setApplet = (item) => {
        let selectedParent = this.state.selectedParent
        selectedParent.type = item.features[0]
        this.setState({ currentApplet: item, selectedParent, fromApplet: false }, () => {
        })
    }

    openAppletSelect = () => {
        this.chooseParent({ type: 'applets', mode: 'system', name: 'applets', },)
    }

    render() {
        const { hideHandlers } = this.props;
        return (
            <div className='w-100 h-100' ref={el => this.firstCurrentNode = el}>
                <button style={{ paddingTop: 7, paddingBottom: 7 }} className={" pld-3 prd-5  flexc br-20 " + (this.state.fixed == true ? " add-element " : " add-element-selected ")} onClick={() => this.openFirstView()}>
                    <img width={20} src='/assets/icons/pagebuilder/plus-black.svg' />
                    <p className='font-size-14 black weight-500'>{translate('Element')}</p>
                </button>
                <div className='w-100 h-100'>
                    <FixedView onHide={() => this.setState({ fixed: true })} ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} fixed={this.state.fixed} topOffset={5} bottomOffset={36} xOffset={285} zIndex={20}  >
                        <div className='br-10 bg-white shadow-3' style={{ width: "400px", height: "300px" }}>
                            {this.state.isLoadingData ? (
                                <div className='flexcc w-100 h-100' >
                                    <ReactLoaderSpinner type={"Oval"} color={this.props.colors?.primaryColor ?? '#eee'} height={40} width={40} />
                                </div>
                            ) : (
                                <div className='flexcb w-100 h-100' >
                                    <div className='h-100' style={{ borderRight: '1px solid #eee', width: "175px", }} >
                                        <div className='h-100'  >

                                            {/* {this.state.isLoadingData && (
                                                    <div className='flexcc w-100 pt-5'>
                                                        <ReactLoaderSpinner type={"Oval"} color={this.props.colors?.primaryColor ?? '#eee'} height={40} width={40} />
                                                    </div>
                                                )} */}

                                            <div className="overflow-auto sc-gray2 w-100 px-1 pb-3" style={{ height: '100%' }}>

                                                <div className=' flexcc pt-1 mb-1' >
                                                    <div className='w-100 flexc ' style={{ borderBottom: "0px solid #eee", height: '30px', cursor: 'auto' }}>
                                                        {/* <p className='px-2 font-size-13 main-c2'>Drag an element</p> */}
                                                        <input placeholder={translate('Search')} className='py-1 px-2 br-5 w-100 text-semibold' style={{ backgroundColor: '#F2F2F2', border: '1px solid #F2F2F7' }} />
                                                    </div>
                                                </div>

                                                {this.state.systemSections.map((section, index) => {
                                                    return (
                                                        <button key={index} className="  w-100 br-4 my-1 flexcb cursor-pointer transition-all" onClick={() => this.chooseParent(section)} style={{ borderLeft: this.state.selectedParent?.type == section.type ? '4px solid #007aff' : '0px solid #fff', backgroundColor: this.state.selectedParent?.type == section.type ? '#007aff20' : '' }}>
                                                            <div className="px-2 flexc py-2 w-100 text-smaller " draggable={false} >
                                                                <div className="flexc" width={22}>
                                                                    <img src={section.icon} width={14} />
                                                                </div>
                                                                <p className="mld-3 text-start text-semibold" style={{ whiteSpace: 'nowrap' }}>{checkTranslation(section.name)}</p>
                                                            </div>
                                                            <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' />
                                                        </button>
                                                    )
                                                })}


                                                <div className="w-100 mt-1" style={{ marginBottom: 3, height: 1, background: '#eee' }}>
                                                </div>


                                                {/* <div className='flexcc ' style={{ borderBottom: "0px solid #eee", zIndex: 10,  }}>
                                                            <div className='w-100 flexcc ' style={{ borderBottom: "0px solid #eee", height: '30px', backgroundColor: "#fff", }}>
                                                                <input placeholder={translate('Search')} className='px-2 py-1 br-5 w-100 text-semibold' style={{ backgroundColor: '#fff', border: '0px solid #F2F2F7' }} />
                                                            </div>
                                                        </div> */}
                                                <div className="">
                                                    <div ref={el => this.appletBut = el} className="px-1 py-1 pb-1 w-100 br-4 mt-0 flexcb transition-all" style={{ backgroundColor: this.state.selectedParent?.type == "applets" ? "#007aff20" : '#f2f2f2', borderLeft: this.state.selectedParent?.type == "applets" ? "4px solid #007aff" : '0px solid #fff', borderBottom: '2px solid rgb(204,204,204)' }}>
                                                        <div className=" flexc text-smaller" style={{ cursor: 'pointer', width: 'calc(100% - 25px)' }} onClick={() => { this.openAppletSelect() }}>
                                                            {this.state.currentApplet ? (
                                                                <>
                                                                    <div className="flexcc">
                                                                        <img draggable={false} src={this.state.currentApplet?.image ? imageAddress(this.state.currentApplet?.image) : ('/assets/icons/applets/' + ((this.state.currentApplet?.features && this.state.currentApplet?.features[0]) ? String(this.state.currentApplet?.features[0]).toLowerCase() : String(this.state.currentApplet?.type).toLowerCase()) + ".png")} className='br-20 ' width={22} />
                                                                    </div>
                                                                    {/* <img draggable={false} src={'/assets/icons/applets/database.png'} className='br-20' width={22} /> */}
                                                                    <div className="mld-2 text-start " draggable={false} style={{ width: 'calc(100% - 25px)' }}>
                                                                        <p className=" font-size-10 "  >{'Selected applet'}</p>
                                                                        <p draggable={false} className="text-bold w-100" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.state.currentApplet?.name)}</p>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="w-100 text-start">
                                                                    <p className=" font-size-10 "  >{'No applet is selected'}</p>
                                                                    <p className=" font-size-10 text-bold"  >{'Click and select a applet'}</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="px-1 flexcc">
                                                            <img src='/assets/icons/useful/setting-1.png' width={14} className='flexcc  rotate-90 ' />
                                                        </div>
                                                    </div>
                                                    <div className="w-100 opacity-2 px-1">
                                                        {/* <div className="br-4 w-100" style={{ height: 2, background: '#000' }}>
                                                        </div> */}
                                                        <div className="flexc w-100  px-1">
                                                            <img src='/assets/icons/useful/sort-down.png' width={12} className='flexcc  ' style={{ transform: 'translate(0px,-2px)' }} />
                                                        </div>
                                                    </div>
                                                </div>



                                                {/* <p className="text-semibold px-2 mt-2 text-small">{translate("Frames units")}</p> */}
                                                {this.state.currentApplet && (
                                                    <div style={{ marginTop: -3 }}>
                                                        {this.state.frames.map((item, index) => {
                                                            if (item && this.state.selectedParent) {
                                                                return (
                                                                    <button className="px-1 py-2 w-100 br-4  flexcb transition-all" key={item._id} onClick={() => { this.setFrame(item) }} style={{ borderLeft: this.state.selectedParent._id == item.applet?._id ? '4px solid #007aff' : '0px solid #fff', backgroundColor: this.state.selectedParent._id == item.applet?._id ? '#007aff20' : '' }}>
                                                                        <div className=" flexc w-100 text-smaller">
                                                                            <img draggable={false} src={item.applet?.image ? imageAddress(item.applet?.image) : ('/assets/icons/applets/' + ((item.applet?.features && item.applet?.features[0]) ? String(item.applet?.features[0]).toLowerCase() : String(item.applet?.type).toLowerCase()) + ".png")} className='br-20 ' width={22} />
                                                                            <div className="mld-2 text-start" draggable={false} style={{ whiteSpace: 'nowrap' }}>
                                                                                <p draggable={false} className="text-semibold font-size-12">{checkTranslation(item.applet?.name)}</p>
                                                                                {/* <p className="color-gray-3 font-size-10"  >{item.features[0]}</p> */}
                                                                            </div>
                                                                        </div>
                                                                        <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' />
                                                                    </button>
                                                                )
                                                            }
                                                        })}
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>



                                    <div className='h-100' style={{ width: "225px", }} >
                                        <div className='px-1 overflow-auto sc-gray2 h-100' style={{}} >

                                            <StagesManager ref={el => this.stageManager = el} fast={true}>


                                                <div stageName="applets" stage={1}>
                                                    <div className="px-2 pt-2 pb-1" style={{ borderBottom: '1px solid #eee' }}>
                                                        <p className="text-small text-bold mb-1">{translate("Select an applet")}</p>
                                                        {/* <p className="text-smaller text-semibold mb-1">{translate("Frames of this applet can be used in the automation")}</p> */}

                                                    </div>
                                                    {this.state.applets?.map((item, index) => {
                                                        if (item && this.state.selectedParent) {
                                                            return (
                                                                <button className="px-1 py-2 w-100 br-4 my-1 flexcb transition-all" key={item._id} onClick={() => { this.selectApplet(item.applet) }} style={{ borderLeft: this.state.selectedParent._id == item.applet?._id ? '4px solid #007aff' : '', backgroundColor: this.state.selectedParent._id == item.applet?._id ? '#007aff20' : '' }}>
                                                                    <div className=" flexc w-100 text-smaller">
                                                                        <img draggable={false} src={item.applet?.image ? imageAddress(item.applet?.image) : ('/assets/icons/applets/' + ((item.applet?.features && item.applet?.features[0]) ? String(item.applet?.features[0]).toLowerCase() : String(item.applet?.type).toLowerCase()) + ".png")} className='br-20' width={22} />
                                                                        <div className="mld-2 text-start" draggable={false} style={{ whiteSpace: 'nowrap' }}>
                                                                            <p draggable={false} className="text-semibold font-size-12">{checkTranslation(item.applet?.name)}</p>
                                                                            {/* <p className="color-gray-3 font-size-10"  >{item.features[0]}</p> */}
                                                                        </div>
                                                                    </div>
                                                                    <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' />
                                                                </button>
                                                            )
                                                        }
                                                    })}
                                                </div>


                                                <div stage={1} stageName="appletSelected" className="text-center flexcc pt-5 flex-column px-3">
                                                    <img src="/assets/icons/useful/check.png" height={30} alt="" />
                                                    <p className="text-small text-semibold mt-2">{translate("Applet selected")}</p>
                                                    <p className="text-smaller">{translate("You can use applet's frames in this automation.")}</p>
                                                </div>


                                                <div stage={0} stageName="units" className='pb-4'>

                                                    <div className='position-sticky top-0 pb-1 pt-1 px-2' style={{ backgroundColor: "#fff", borderBottom: "1px solid #eee", zIndex: 10 }}>
                                                        <div className='w-100   flexc ' style={{ borderBottom: "0px solid #eee", height: '30px', cursor: 'auto' }}>
                                                            <p className="text-small text-bold ">{checkTranslation(this.state.selectedParent?.name)}</p>
                                                            {/* <input placeholder={translate('Search')} className='py-1 px-2 br-5 w-100' style={{ backgroundColor: '#F2F2F7', border: '1px solid #F2F2F7' }} /> */}
                                                        </div>
                                                    </div>

                                                    {/* {console.log('currentapplettttttt', this.state.currentApplet)} */}
                                                    {/* {(!this.state.currentapplet?._id) ? (
                                                    !this.state.fromApplet &&
                                                    <div className='flexcc w-100 pt-5'>
                                                        <ReactLoaderSpinner type={"Oval"} color={this.props.colors?.primaryColor ?? '#eee'} height={40} width={40} />
                                                    </div>
                                                    ) : ( */}
                                                    {Object.values(widgetsList).map((formItem, index) => {

                                                        if (((formItem.parents?.includes(this.state.selectedParent?.type) || (this.state.selectedParent?.features && formItem.parents?.includes(this.state.selectedParent?.features[0])) || (formItem.parents?.includes('*'))) && (!this.state.currentTab || this.state.currentTab == formItem.group))) {

                                                            // console.log('forrrrrrrrrrrrrm', formItem, this.state.selectedParent?.type)
                                                            // if (formItem.parents && this.state.selectedParent?.type && (formItem.parents.includes(this.state.selectedParent.type) || formItem.parents.includes('all'))) {
                                                            return (
                                                                <div className="py-2 w-100 d-flex" style={{ cursor: 'move', justifyContent: 'space-between' }} key={index} onDragStart={(e) => this.onDragStart(e, index, formItem.key)} onDragEnd={hideHandlers} draggable={true}>
                                                                    <div className='d-flex'>
                                                                        <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 prd-2 mt-2' />
                                                                        <div key={index} className=" d-flex w-100 text-smaller mt-1" style={{}}>
                                                                            <img draggable={false} src={formItem.icon} height={22} />
                                                                            <div className='mld-3' style={{ marginTop: 0 }}>
                                                                                <div className='flexcb'>
                                                                                    <p draggable={false} className='text-bold' >{checkTranslation(formItem.label)}</p>
                                                                                    {/* <HelpButton data={formItem?.description} /> */}
                                                                                </div>
                                                                                {formItem.description && (
                                                                                    <p draggable={false} className="text-smallest">{checkTranslation(formItem.description)}</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                    {/* )} */}
                                                </div>

                                            </StagesManager>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </FixedView>
                </div >
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageBuilderAddElements);